<template>
  <div class="layouts-combining-assets-photos-graphic-content" id="identidade-visual-combinando-os-assets-logo-texto-foto-e-grafismo" data-search-anchor>
    <div class="description-layouts-combining-assets-photos-graphic-wrapper">
      <div class="icon-wrapper">
        <IconCheck />
        <p class="layouts-combining-assets-photos-graphic-description">
          {{ layoutsCombiningAssetsPhotosGraphicDescription }}
        </p>
      </div>

      <div class="icon-wrapper">
        <IconCheck />
        <p class="layouts-combining-assets-photos-graphic-description">
          {{ layoutsCombiningAssetsPhotosGraphicDescription1 }}
        </p>
      </div>

      <div class="icon-wrapper">
        <IconCheck />
        <p class="layouts-combining-assets-photos-graphic-description">
          {{ layoutsCombiningAssetsPhotosGraphicDescription2 }}
        </p>
      </div>

      <div class="icon-wrapper">
        <IconCheck />
        <p class="layouts-combining-assets-photos-graphic-description">
          {{ layoutsCombiningAssetsPhotosGraphicDescription3 }}
        </p>
      </div>
    </div>
    <div
      class="layouts-combining-assets-photos-graphic-card-item"
      :style="{ backgroundImage: `url(${layoutsCombiningAssetsPhotosGraphicImageSrc})` }"
    ></div>
  </div>
</template>

<script lang="ts">
import IconCheck from '@/assets/icons/IconCheck.vue'
import { PageStoreContract } from '@/data/store/page.store.contract'
import LayoutPageMixin from '@/mixins/layout-page-mixin'
import { LayoutPageStore } from '@/store/visual-identity-page/layout-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({ components: { IconCheck } })
export default class LayoutsCombinigAssetsPhotosGraphicSection extends Mixins(LayoutPageMixin) {
  layoutPageStore: PageStoreContract = getModule(LayoutPageStore, this.$store)

  get layoutsCombiningAssetsPhotosGraphicDescription(): string {
    return this.getElementText(5, 0)
  }

  get layoutsCombiningAssetsPhotosGraphicDescription1(): string {
    return this.getElementText(5, 1)
  }

  get layoutsCombiningAssetsPhotosGraphicDescription2(): string {
    return this.getElementText(5, 2)
  }

  get layoutsCombiningAssetsPhotosGraphicDescription3(): string {
    return this.getElementText(5, 3)
  }

  get layoutsCombiningAssetsPhotosGraphicImageSrc(): string {
    return this.getElementMedia(5, 4)
  }

  async getLayoutPage(): Promise<void> {
    await this.layoutPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.layoutPageStore.isLoading) {
      await this.getLayoutPage()
    }
  }
}
</script>

<style lang="scss">
.layouts-combining-assets-photos-graphic-content {
  display: grid;

  width: 100%;
  max-width: 1032px;
}

.description-layouts-combining-assets-photos-graphic-wrapper {
  padding: 2rem 0rem 0rem 0rem;
  position: relative;  

  display: grid;
  grid-template-columns: 51% 49%;
}

.layouts-combining-assets-photos-graphic-title-span {
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  margin-right: 5px;
  color: #b3b3b3;
}

.layouts-combining-assets-photos-graphic-title {
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  color: #000000;
}

.layouts-combining-assets-photos-graphic-description {
  font-size: 25px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;

  padding-left: 7px;
  width: 374px;
}

.layouts-combining-assets-photos-graphic-card-item {
  position: relative;  

  max-width: 1032px;
  width: 100%;
  height: 705px;

  background-repeat: no-repeat;
  background-size: contain;
}
</style>
